module.exports = __webpack_public_path__ + "img/gestaltra_logo-reversed.dae6a75b.png";